import { Button } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslations } from "use-intl";

import { Footer } from "@/components/Footer/Footer";
import { IconHeadphones, IconWhatsApp } from "@/components/Icons";
import { CommonTrackingEvents, rudderAnalytics } from "@/lib/rudderstack";
import { WHATSAPP_URL } from "@/utils/constants";

export const Route = createFileRoute("/_authenticated/chat")({
  component: RouteComponent,
});

function RouteComponent() {
  const t = useTranslations();

  return (
    <main className="main flex flex-col items-center justify-center p-4">
      <div className="mb-[calc((var(--main-bottom-padding)+var(--footer-height))/2)] flex flex-col items-center rounded-2xl bg-white p-4 text-center shadow-sm">
        <IconHeadphones
          className="mb-4 size-29 bg-radial-[closest-side] from-surface-accent-soft p-4"
          aria-hidden
        />

        <h2 className="text-xl font-medium text-text-title">
          {t("chat.widget.title")}
        </h2>
        <div className="mt-2 text-sm text-text-placeholder">
          {t("chat.widget.description")}
        </div>

        <Button
          onClick={() => {
            rudderAnalytics.track(CommonTrackingEvents.USER_CONTACTED_SUPPORT);
          }}
          href={WHATSAPP_URL}
          variant="contained"
          color="whatsapp"
          sx={{
            borderRadius: "var(--radius-2xl)",
            mt: "calc(var(--spacing) * 4)",
            fontSize: "var(--text-sm)",
          }}
          disableElevation
          fullWidth
          startIcon={<IconWhatsApp className="size-5" aria-hidden />}
        >
          {t("chat.widget.button")}
        </Button>
      </div>

      <Footer />
    </main>
  );
}
